// eslint-disable-next-line import/no-unresolved
const addressHelpers = require('base/checkout/address');
const utils = require('../utils');
const shipping = require('./shipping');

function updateShippingMethodListDifferentPostalCode($shippingForm) {
    const defer = $.Deferred();
    const $shippingMethodList = $shippingForm.find('.shipping-method-list');
    const urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
    const shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
    const url = $shippingMethodList.data('actionUrl');
    urlParams.shipmentUUID = shipmentUUID;

    $shippingMethodList.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams,
        // eslint-disable-next-line func-names
        success: function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer,
                        options: { keepOpen: true },
                    });

                $shippingMethodList.spinner().stop();
            }
            return defer.resolve(data); // eslint-disable-line
        },
        // eslint-disable-next-line func-names
        error: function (data) {
        	return defer.resolve(data);; // eslint-disable-line
        },
    });

    return defer;
}


function selectDeliveryPoint(e, deliveryPointsStoreResults) {
    deliveryPointsStoreResults.find("[id^='input-']").on('click', () => {
        $('.select-store-deliveryPoint').removeAttr('disabled');
    });
    $('.select-deliveryPoint-input').on('click', (ev) => {
        ev.preventDefault();
        const selectedPoint = $('input[name="deliveryPoint"]:checked');
        const storeDetailsHtml = selectedPoint.parent().find('.store-details').html();

        const data = {
            storeID: selectedPoint.val(),
            searchRadius: '',
            searchPostalCode: '',
            storeDetailsHtml,
            event: e,
        };

        const newLabel = $(data.storeDetailsHtml);
        const content = $('<div class="selectedStore store-details"></div>').append(newLabel).append(`<input type="hidden" id="deliveryPointStore" name="storeId" value="${data.storeID}" />`);

        deliveryPointsStoreResults.fadeOut(300, function(){
          deliveryPointsStoreResults.empty().append(content);
          $('.store-selected-hidden-wrapper').removeClass('d-none');
          if (deliveryPointsStoreResults.is(':hidden')) {
              deliveryPointsStoreResults.show();
          }
          deliveryPointsStoreResults.fadeIn();
        });

        $('.change-store').removeClass('d-none');

        $('.deliveryPointForm').fadeOut(300, function(){
          $('.deliverypoint-in-store .first, .deliverypoint-in-store .last, deliveryPointForm').hide();
          $('.deliveryPointForm').hide();
        });
    });
}

function areUpdatedShippings(order) {
    const shippingsDisplay = $("input[id^='shippingMethod-']");
    let updateShippings = false;
    const shippings = order.shipping;
    if (shippings && shippings.length > 0) {
        const aplicableShippings = shippings[0].applicableShippingMethods;
        aplicableShippings.forEach((shippingToCheck) => {
            let shippingExist = false;
            shippingsDisplay.each((index, shippingDisplayed) => {
                if ($(shippingDisplayed).val() === shippingToCheck.ID) {
                    shippingExist = true;
                }
            });
            if (!shippingExist) {
                updateShippings = true;
            }
        });
    }

    return updateShippings;
}

function assignEvent() {
    $('.btn-deliveryPoint-search').on('click', (e) => {
        $.spinner().start();
        e.preventDefault();
        $('.deliverypoints-form').html('');
        const $deliveryPointStore = $('.deliverypoint-in-store');
        const url = $deliveryPointStore.attr('data-url');
        $deliveryPointStore.find('.invalid-feedback').html('');

        const cp = $('#deliveryPointPostalCode').val();
        const city = $('#deliveryPointCity').val();

        const requestData = {
            city,
            cp,
            country: $('#deliveryPointCountry').val(),
        };
        const newUrl = utils.appendToUrl(url, requestData);
        $.ajax({
            url: newUrl,
            method: 'POST',
            success(response) {
                if (response.success) {
                    const deliveryPointsStoreResults = $('#deliverypoint-in-store-store-result');
                    const { order } = response;
                    if (order) {
                        const updateShippings = areUpdatedShippings(order);
                        if (updateShippings) {
                            const form = $(e.currentTarget.form);
                            shipping.methods.updateShippingAddressFormValues(order.shipping[0]);

                            const promise = updateShippingMethodListDifferentPostalCode(form);

                            promise.done(() => {
                                const shippingsDisplay = $("input[id^='shippingMethod-']");
                                // eslint-disable-next-line consistent-return
                                shippingsDisplay.each((index, shippingDisplayed) => {
                                    if ($(shippingDisplayed).data('deliverypoint')) {
                                        $(shippingDisplayed).attr('checked', 'checked');
                                        $('.shipping-method-list').trigger('change');
                                        return true;
                                    }
                                });
                            });
                        } else {
                            deliveryPointsStoreResults.empty().html(response.renderedTemplate);
                            selectDeliveryPoint(e, deliveryPointsStoreResults);
                        }
                    } else {
                        deliveryPointsStoreResults.empty().html(response.renderedTemplate);
                        selectDeliveryPoint(e, deliveryPointsStoreResults);
                    }
                } else if (response.fieldErrors.length) {
                    response.fieldErrors.forEach((error) => {
                        if (Object.keys(error).length) {
                            const componentError = $(`#${error.field}`).parent().find('.invalid-feedback');
                            componentError.html(`<p>${error.errorMessage}</p>`);
                        }
                    });
                } else {
                    const errorMessage = response.message;
                    $('.deliverypoints-form').html(errorMessage);
                }
                $.spinner().stop();
            },
        });
    });
}


/**
 * Hide store finder and restore address form
 * @param {Object} shippingForm - DOM element with current form
 * @param {Object} data - data containing customer and order objects
 */
function hideDeliveryPointFinder(shippingForm) {
    shippingForm.find('.deliverypoint-in-store').addClass('d-none');
    shippingForm.find('.change-store').addClass('d-none');
    shippingForm.find('.gift-message-block').removeClass('d-none');

    shippingForm.find('input[name="storeId"]').remove();
}

/**
 * Show store locator when appropriate shipping method is selected
 * @param {Object} shippingForm - DOM element that contains current shipping form
 */
function showDeliveryPointFinder(shippingForm) {
    const $clickStore = shippingForm.find('.deliverypoint-in-store');

    $clickStore.removeClass('d-none');

    $('#deliverypoint-in-store-store-result').html('');

    $('.deliveryPointSelected').addClass('d-none');

    if (!$clickStore.find('.first').is('visible')) {
        $clickStore.find('.first').show();
    }
    if (!$clickStore.find('.last').is('visible')) {
        $clickStore.find('.last').show();
    }
    if (!$('.deliveryPointForm').is(':visible')) {
        $('.deliveryPointForm').show();
    }
    $('.btn-deliveryPoint-search').unbind();

    shippingForm.find('.change-store').addClass('d-none');

    assignEvent();
}


module.exports = {
    showDeliveryPointFinder,
    hideDeliveryPointFinder,
    assignEvent,
};
